import { useMutation } from 'react-query';

import { imageComponentUploadImage as mutationFn } from 'api/endPoints/imageComponentUploadImage';

export const useImageComponentUploadImage = () => {
    return useMutation<unknown, QueryError, unknown>((params) => mutationFn(params));
};
